import { render, staticRenderFns } from "./CobrancaFilial.vue?vue&type=template&id=4a9ecf98"
import script from "./CobrancaFilial.vue?vue&type=script&lang=js"
export * from "./CobrancaFilial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports